import { Button } from '@bepure/tarkin';
import React from 'react';
import {useState} from "react";
import Popup from './Popup';

declare const RECHARGE_PRODUCT_DATA: any;

interface ToggleableSubscriptionProps {
    productPrice : number;
    id : number;
    setSubscriptionState : Function;
}
interface PurchaseTypeProps {
    title?: string;
    price: string;
    subtext: string[];
    isSubscription: boolean;
    setSubscription: Function;
    openPopup?: Function;
}

const ToggleableSubscription = (props : ToggleableSubscriptionProps) => {
    const [isSubscription, setIsSubscription] = useState(false);
    const [popupOpen, setPopupOpen] = useState(false)

    let discount = RECHARGE_PRODUCT_DATA.find((x:any) => x.id === props.id).subscriptions[0]?.discount_amount;
    let undiscountedprice = props.productPrice.toFixed(2);
    let discountedprice = (props.productPrice * (100-discount)/100).toFixed(2);

    const purchase = {
        title:"One-time purchase",
        price: undiscountedprice, 
        subtext:["No perks for me please.", "Afterpay and Laybuy available"] 
    }

    const subscription = {
        title: null,
        price: discountedprice, 
        subtext: ["Save up to 20% on subscription", "plus get perky perks like freebies"]
    }

    props.setSubscriptionState(isSubscription)

   return ( 
    <div className="toggleable-subscriptions">
        <div className={"toggleable-subscriptions__tick toggleable-subscriptions__tick__" + (isSubscription ? "right" : "left")}>
            <img src="https://s3-ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/EveWellness/Icons/Eve_Tick_30x30.svg"></img>
        </div>
        <div className={"toggleable-subscriptions__left-part toggleable-subscriptions__" + (isSubscription ? "inactive" : "active")}>
            <PurchaseType title={purchase.title} price={purchase.price} subtext={purchase.subtext} 
            isSubscription={false} setSubscription={setIsSubscription}></PurchaseType>
        </div>
        <div className={"toggleable-subscriptions__right-part toggleable-subscriptions__" + (isSubscription ? "active" : "inactive")}>
            <PurchaseType title={subscription.title} price={subscription.price} subtext={subscription.subtext} 
            isSubscription={true} setSubscription={setIsSubscription} openPopup={setPopupOpen}></PurchaseType>
        </div>
        <Popup 
                onClose={() => setPopupOpen(false)}
                open={popupOpen}
                imageSrc={{
                    desktopSrc: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Raster_Images/Friends+with+benefits/FWB_PopUp_Desktop_1064x535_150dpi.png',
                    mobileSrc: 'https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Raster_Images/Friends+with+benefits/FWB_PopUp_Mobile_325x567_150dpi.png'
                }}
            >
                <>
                    <p>Read our <a href='/terms-and-conditions'>Terms & Conditions</a> for more information</p>
                    <Button 
                        ariaLabel={"learn more"}
                        text={'LEARN MORE'}
                        onClick={() => window.location.href = '/friends-benefits'}
                    />
                </>
        </Popup>
    </div>
    )
}


const PurchaseType = (props: PurchaseTypeProps) => {
    
    const subscriptionClickedHandler = () => {
        if(!props.isSubscription){
            props.setSubscription(false);
        }
        else if(props.isSubscription){
            props.setSubscription(true);
        }
        
    }
    return(
    <div className="toggleable-subscriptions__content" onClick={subscriptionClickedHandler}>
        
        
       {props.title && 
       <div className="toggleable-subscriptions__content__title">
            {props.title}
        </div>}

        {props.isSubscription &&
        <div>
            <img className="toggleable-subscriptions__content__title-image-desktop" src ="https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Friends+with+benefits/FriendsWithBenfits_Logo.svg"></img>
            <img className="toggleable-subscriptions__content__title-image-mobile" src ="https://s3.ap-southeast-2.amazonaws.com/static.bepure.co.nz/Arwen/Icons/Friends+with+benefits/Friends_Logo.svg"></img>
        </div>}

        

        <div className="toggleable-subscriptions__content__subtext">

            {
                props.subtext.map((line: string) => 
                <div className="toggleable-subscriptions__content__subtext__text" key={line}>{line}</div>
            )
            }
            
            {(props.isSubscription && props.openPopup) &&  
            <a onClick={() => props.openPopup!(true)}>Learn More</a>
        }
        </div>

    </div>
    )
}


export default ToggleableSubscription;